import { smoothScroll } from '../utils/scroll';

export const initSmoothScroll = () => {
  function triggerBackToTop() {
    const backToTopButton = document.querySelector('.js-b2t');

    if (!backToTopButton) return;

    backToTopButton.addEventListener("click", () => {
      smoothScroll();
    });
  }

  function anchorScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      // Skip ACF repeater add buttons to prevent unwanted scroll
      if (anchor.classList.contains('acf-repeater-add-row')) {
        return;
      }
      
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        smoothScroll(anchor.getAttribute('href'));
      });
    });
  }

  function handleHashScroll() {
    const hash = window.location.hash;

    if (hash) {
      window.scrollTo(0, 0);

      const target = document.querySelector(hash);

      if (target) {
        smoothScroll(target)
      }
    }
  }

  return {
    init() {
      triggerBackToTop();
      anchorScroll();
      handleHashScroll();
    },
  }
}
